import { v4 as uuidv4 } from 'uuid';
import moment from 'moment';

const CACHE_KEY_SESSION_ID = "session_id"
const CACHE_KEY_SESSION_EXPIRY = "session_expiry"
const CACHE_KEY_PREVIOUS_PAGE_CODE = "previous_page_code"

export function setCookie(cName, cValue, expDays) {
  let date = new Date();
  date.setTime(date.getTime() + (expDays * 24 * 60 * 60 * 1000));
  const expires = "expires=" + date.toUTCString();
  document.cookie = cName + "=" + cValue + "; " + expires + "; path=/";
}

export function getCookie(cName) {
  const name = cName + "=";
  const cDecoded = decodeURIComponent(document.cookie); //to be careful
  const cArr = cDecoded .split('; ');
  let res;
  cArr.forEach(val => {
      if (val.indexOf(name) === 0) res = val.substring(name.length);
  })
  return res;
}

export function getAddress(cc, lang) {
  const uaeAddr = lang === 'en'
    ? 'Tamara FZE, WeWork, Level 9, The Offices 4, One Central, DWTC Dubai, United Arab Emirates'
    : 'تمارا م.م.ح، وي وورك، الدور التاسع، المكاتب 4، ون سنترال، مركز دبي التجاري العالمي دبي، الإمارات العربية المتحدة';
  const ksaAddr = lang === 'en'
    ? 'Nakhla IT Systems LLC, 6901 At Takhassusi Branch Street, Al Rahmaniyah District Riyadh, Saudi Arabia'
    : 'شركة نخلة لتقنية نظم المعلومات،6901 طريق التخصصي الفرعي، حي الرحمانية الرياض، المملكة العربية السعودية';
  return cc === 'ae'
    ? uaeAddr
    : ksaAddr
}

export const PAGE_CODE_HOMEPAGE_SCREEN = "web_homepage_screen_view"
export const PAGE_CODE_STORE_DIRECTORY = "web_store_directory_view"
export const PAGE_CODE_ABOUT = "web_about_view"
export const PAGE_CODE_APP = "web_app_view"
export const PAGE_CODE_ARTICLE = "web_article_view"
export const PAGE_CODE_CAREERS = "web_careers_view"
export const PAGE_CODE_CASE_STUDIES = "web_case_studies_view"
export const PAGE_CODE_DEAL_TERMS_AND_CONDITIONS = "web_deal_terms_and_conditions_view"
export const PAGE_CODE_BLOG = "web_blog_view"
export const PAGE_CODE_INDEX = "web_index_view"
export const PAGE_CODE_PRESS = "web_press_view"
export const PAGE_CODE_FARAH_PROGRAM = "web_farah_program_view"
export const PAGE_CODE_IKEA_CASE_STUDY = "web_ikea_case_study_view"
export const PAGE_CODE_PARTNERS = "web_partners_view"
export const PAGE_CODE_PRIVACY_POLICY = "web_privacy_policy_view"
export const PAGE_CODE_REFERRAL_TERMS_AND_CONDITIONS = "web_referral_terms_and_conditions_view"
export const PAGE_CODE_RESPONSIBLE_DISCLOSURE = "web_responsible_disclosure_view"
export const PAGE_CODE_SHARIAH_COMPLIANCE = "web_shariah_compliance_view"
export const PAGE_CODE_STATIC = "web_static_view"
export const PAGE_CODE_STORES = "web_stores_view"
export const PAGE_CODE_TAMARA_SERIES_B = "web_tamara_series_b_view"
export const PAGE_CODE_TERMS_AND_CONDITIONS_AE = "web_terms_and_conditions_ae_view"
export const PAGE_CODE_TERMS_AND_CONDITIONS_KW = "web_terms_and_conditions_kw_view"
export const PAGE_CODE_TERMS_AND_CONDITIONS = "web_terms_and_conditions_view"
export const PAGE_CODE_WALLET_TERMS_AND_CONDITIONS = "web_wallet_terms_and_conditions_view"

const PAGE_CODES = {
	[PAGE_CODE_HOMEPAGE_SCREEN]: "index.html",
	[PAGE_CODE_STORE_DIRECTORY]: "stores.html",
	[PAGE_CODE_ABOUT]: "about.html",
	[PAGE_CODE_APP]: "app.html",
	[PAGE_CODE_ARTICLE]: "article.html",
	[PAGE_CODE_CAREERS]: "careers.html",
	[PAGE_CODE_CASE_STUDIES]: "case-studies.html",
	[PAGE_CODE_DEAL_TERMS_AND_CONDITIONS]: "deal-terms-and-conditions.html",
	[PAGE_CODE_BLOG]: "blog.html",
	[PAGE_CODE_INDEX]: "index.html",
	[PAGE_CODE_PRESS]: "press.html",
	[PAGE_CODE_FARAH_PROGRAM]: "farah-program.html",
	[PAGE_CODE_IKEA_CASE_STUDY]: "ikea-case-study.html",
	[PAGE_CODE_PARTNERS]: "partners.html",
	[PAGE_CODE_PRIVACY_POLICY]: "privacy-policy.html",
	[PAGE_CODE_REFERRAL_TERMS_AND_CONDITIONS]: "referral-terms-and-conditions.html",
	[PAGE_CODE_RESPONSIBLE_DISCLOSURE]: "responsible-disclosure.html",
	[PAGE_CODE_SHARIAH_COMPLIANCE]: "shariah-compliance.html",
	[PAGE_CODE_STATIC]: "static.html",
	[PAGE_CODE_STORES]: "stores.html",
	[PAGE_CODE_TAMARA_SERIES_B]: "tamara-series-b.html",
	[PAGE_CODE_TERMS_AND_CONDITIONS_AE]: "terms-and-conditions-ae.html",
	[PAGE_CODE_TERMS_AND_CONDITIONS_KW]: "terms-and-conditions-kw.html",
	[PAGE_CODE_TERMS_AND_CONDITIONS]: "terms-and-conditions.html",
	[PAGE_CODE_WALLET_TERMS_AND_CONDITIONS]: "wallet-terms-and-conditions.html",
}

export function getPageCode(pathname) {
	if (["/", "/en/index.html", "/index.html"].indexOf(pathname) > -1) {
		return "web_homepage_screen_view"
	}

	pathname = pathname.replace("/en/", "/").replace(/^\//, "")

	const pageCodeKeys = Object.keys(PAGE_CODES)

	const pageCode = pageCodeKeys.find(pageCodeKey => PAGE_CODES[pageCodeKey] === pathname)

	return pageCode || ""
}

export function getSessionId() {
	const cachedSessionId = window.localStorage.getItem(CACHE_KEY_SESSION_ID)
	const cachedSessionExpirySerialized = window.localStorage.getItem(CACHE_KEY_SESSION_EXPIRY)
	const hasCachedSessionExpiry = window.localStorage.hasOwnProperty(CACHE_KEY_SESSION_EXPIRY)
	const cachedSessionExpiry = new Date(cachedSessionExpirySerialized)
	const sessionIdExpired = cachedSessionId && hasCachedSessionExpiry && moment(cachedSessionExpiry).isBefore()

	if (!cachedSessionId || sessionIdExpired) {
		const sessionId = uuidv4()

		window.localStorage.setItem(CACHE_KEY_SESSION_ID, sessionId)

		window.localStorage.setItem(
			CACHE_KEY_SESSION_EXPIRY,
			moment().add(30, "minutes").toDate().toJSON(),
		)

		return sessionId
	}

	return cachedSessionId
}

export function buildDataAttributes(obj) {
	const keys = Object.keys(obj)

	return keys.map(key => `data-${key}="${obj[key]}"`).join(" ")
}

export function getPreviousVisitedPage() {
	return window.localStorage.getItem(CACHE_KEY_PREVIOUS_PAGE_CODE)
}

export function setPreviousVisitedPage(pageCode) {
	return window.localStorage.setItem(CACHE_KEY_PREVIOUS_PAGE_CODE, pageCode)
}

export function removeNullFields(obj) {
	let objModified = {}

	const keys = Object.keys(obj)

	for (let i = 0; i < keys.length; i++) {
		if (obj[keys[i]] === null || typeof obj[keys[i]] === "undefined") {
			continue
		}

		objModified[keys[i]] = obj[keys[i]]
	}

	return objModified
}

export function removeFieldsOfTypes(obj, typesToBeRemoved) {
	let objModified = {}

	const keys = Object.keys(obj)

	for (let i = 0; i < keys.length; i++) {
		if (typesToBeRemoved.indexOf(typeof obj[keys[i]]) > -1) {
			continue
		}

		objModified[keys[i]] = obj[keys[i]]
	}

	return objModified
}
